import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=00975cc1&"
import script from "./Pagination.vue?vue&type=script&lang=ts&"
export * from "./Pagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00975cc1')) {
      api.createRecord('00975cc1', component.options)
    } else {
      api.reload('00975cc1', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=00975cc1&", function () {
      api.rerender('00975cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/pagination/Pagination.vue"
export default component.exports